<script setup>
import { router, usePage } from '@inertiajs/vue3';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

// Icon
import arrow from '@i/arrow-down.svg';

// Components
import Icon from '@/Components/Images/Icon.vue';

const i18n = useI18n();
const showLang = ref(false);
let locales = Object.keys(usePage().props.route.locale);

// The current locale
const locale = computed(() => usePage().props.locale);
const currentLocale = ref(locale);

// Call to switch to locale
const switchLocale = (event) => {
    const locale = event.target.innerText.toLowerCase();

    i18n.locale.value = locale;
    console.log(usePage().props.route.locale[locale]);

    router.get(usePage().props.route.locale[locale], {}, { preserveScroll: true });
};

locales = locales.filter((item) => item != currentLocale.value);
</script>

<template>
    <div
        v-if="Object.keys(usePage().props.route.locale).length > 1"
        class="relative"
    >
        <div
            class="top-0 flex gap-2"
            @click="showLang = !showLang"
        >
            <button class="flex items-center gap-2 rounded-xl bg-primary px-5 py-2 font-bold xl:bg-transparent xl:px-0">
                <span class="flex items-center gap-2 text-base">
                    {{ locale.toUpperCase() }}
                    <Icon
                        class="h-2 w-3 items-center transition-all xl:hidden"
                        :class="{ '-rotate-180': showLang }"
                        :icon="arrow"
                        alt="icon"
                    />
                </span>
            </button>
            <button>
                <Icon
                    class="hidden h-4 w-4 items-center transition-all xl:flex"
                    :class="{ '-rotate-180': showLang }"
                    :icon="arrow"
                    alt="icon"
                />
            </button>
        </div>
        <div
            :class="{ hidden: !showLang }"
            class="xl:min-w-auto absolute top-14 z-50 min-w-20 rounded-xl bg-primary px-5 py-3 pb-2 font-bold text-white xl:min-w-10 xl:rounded-2xl xl:bg-white xl:py-3 xl:text-bodyColor xl:drop-shadow-md"
        >
            <div class="absolute -top-1 left-5 h-3 w-3 rotate-45 bg-primary xl:bg-white" />

            <button
                v-for="(locale, i) in locales"
                :key="i"
                class="flex flex-col items-center gap-2"
                href="#"
                @click="switchLocale($event)"
            >
                <p
                    ref="seletedLocale"
                    class="block uppercase transition-colors duration-300 hover:text-primary"
                    v-html="locale"
                />
            </button>
        </div>
    </div>
</template>
